import * as React from "react";
const Root = "div";
interface Props extends React.ComponentPropsWithoutRef<typeof Root> {
  label?: React.ReactNode;
}
function Action(props: Props) {
  const {
    label,
    ...rest
  } = props;
  return <div className={classes.root} {...rest}>
      <div className={classes.icon}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </div>
      <div className={classes.label}>{label}</div>
    </div>;
}
export default Action;
const classes = {
  root: "ru1mblv",
  icon: "i1wyx06o",
  label: "legxg01"
};

require("./Action.linaria.module.css!=!../../../../../../node_modules/.pnpm/@linaria+webpack5-loader@5.0.4_webpack@5.91.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Action.tsx");